import { Menu, MenuDivider, MenuItem } from "@blueprintjs/core";
import { IDisposable } from "monaco-editor-core";
import ReactDOM from "react-dom";

import { Vec2 } from "../../Data/Geometry/Vec2";
import styles from "./ContextMenuPopup.module.css";

export class MenuPopup implements IDisposable {
  constructor(position: Vec2, private listener: MenuPopup.Events) {
    this.cont = document.createElement("div");
    this.cont.classList.add(styles.cont, "bp3-popover", "bp3-minimal");
    this.cont.style.left = "" + position.x + "px";
    this.cont.style.top = "" + position.y + "px";

    this.cont.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });

    document.body.appendChild(this.cont);

    ReactDOM.render(
      <ContextMenu
        onCutClick={this.listener.onCutClick}
        onCopyClick={this.listener.onCopyClick}
        onPasteClick={this.listener.onPasteClick}
      />,
      this.cont,
      () => {
        console.log("RENDERED");
        console.log("clientWidth", this.cont.clientWidth);
        console.log("clientWidth", this.cont.clientHeight);
        console.log(JSON.stringify(this.cont.getBoundingClientRect, null, 2));
      }
    );
  }

  getSize(): { width: number; height: number } {
    return {
      width: 1,
      height: 1
    };
  }

  dispose(): void {
    ReactDOM.unmountComponentAtNode(this.cont);
    document.body.removeChild(this.cont);
  }

  private cont: HTMLElement;
}

export declare namespace MenuPopup {
  export interface Events {
    onCutClick: () => void;
    onCopyClick: () => void;
    onPasteClick: () => void;
  }
}

interface ContextMenuProps {
  onCutClick: () => void;
  onCopyClick: () => void;
  onPasteClick: () => void;
}

function ContextMenu(props: ContextMenuProps): JSX.Element {
  return (
    <Menu>
      <MenuDivider title="Edit" />
      <MenuItem text="Cut" label="Ctrl+X" icon="cut" onClick={props.onCutClick} />
      <MenuItem text="Copy" label="Ctrl+C" icon="duplicate" onClick={props.onCopyClick} />
      <MenuItem text="Paste" label="Ctrl+V" icon="clipboard" onClick={props.onPasteClick} />
    </Menu>
  );
}
